<script>
import {Bar} from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    assetData: {},
    assetList: [],
  },
  data: function () {
    return {
      chartLabels: ['금월', '6개월', '12개월', '18개월', '24개월', '30개월', '36개월'],
      chartBeforeData: [],
      chartAfterData: []
    }
  },
  created: function () {
    let count = Math.floor(this.assetList.length / 6) + 1
    this.chartLabels = this.chartLabels.splice(0, count)
    this.chartBeforeData.push(this.assetData.savePrice)
    // this.chartAfterData.push(this.assetData.afterTotalBill1)

    if (count > 1) {
      for (let i = 1; i < count; i++) {
        let spliceAssetList = this.$_.clone(this.assetList).splice(0, i * 6)
        this.chartBeforeData.push(
          spliceAssetList.map(item => item.savePrice).reduce((before, after) => before + after, 0)
        )
        // this.chartAfterData.push(
        //   spliceAssetList.map(item => item.afterTotalBill1).reduce((before, after) => before + after, 0)
        // )
      }
    }
  },
  mounted: function () {
    const chartData = {
      labels: this.chartLabels,
      datasets: [
        {
          label: '절감액',
          borderWidth: 1,
          borderColor: '#42A2BF',
          backgroundColor: 'rgba(66,162,191,0.5)',
          barThickness: 20,
          data: this.chartBeforeData
        },
        // {
        //   label: '컨설팅 전',
        //   borderWidth: 1,
        //   borderColor: '#dc3545',
        //   backgroundColor: 'rgba(220, 53, 69, 0.5)',
        //   barThickness: 20,
        //   data: this.chartBeforeData
        // },
        // {
        //   label: '컨설팅 후',
        //   borderWidth: 1,
        //   borderColor: '#42A2BF',
        //   backgroundColor: 'rgba(66,162,191,0.5)',
        //   barThickness: 20,
        //   data: this.chartAfterData
        // }
      ],
    }

    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              stepSize: this.chartBeforeData.length > 1 ? 50000 : 5000,
              min: 0
            }
          }
        ]
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) { //그래프 콤마
            return tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "원";
          }
        }
      }
    }

    this.renderChart(chartData, options)
  }
}
</script>
